import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { slideDownUp } from '../shared/animations';
import { AccessService } from '../core/services/access.service';
import { MENU_ITEMS, MenuItem } from './menu-items';
import { IconMenuDashboardComponent } from '../shared/icon/menu/icon-menu-dashboard';
import { IconAirplayComponent } from '../shared/icon/icon-airplay';
import { IconMenuDocumentationComponent } from '../shared/icon/menu/icon-menu-documentation';
import { IconMenuFormsComponent } from '../shared/icon/menu/icon-menu-forms';
import { IconMenuElementsComponent } from '../shared/icon/menu/icon-menu-elements';
import { IconMenuDatatablesComponent } from '../shared/icon/menu/icon-menu-datatables';
import { IconMenuNotesComponent } from '../shared/icon/menu/icon-menu-notes';
import { IconMenuUsersComponent } from '../shared/icon/menu/icon-menu-users';
import { IconUserComponent } from '../shared/icon/icon-user';
import { IconBoxComponent } from '../shared/icon/icon-box';
import { IconCashBanknotesComponent } from '../shared/icon/icon-cash-banknotes';
import { IconMenuAuthenticationComponent } from '../shared/icon/menu/icon-menu-authentication';
import { IconMenuTablesComponent } from '../shared/icon/menu/icon-menu-tables';
import { IconMenuContactsComponent } from '../shared/icon/menu/icon-menu-contacts';
import { IconMapPinComponent } from '../shared/icon/icon-map-pin';
import { IconFolderComponent } from '../shared/icon/icon-folder';
import { lastValueFrom } from 'rxjs';
import { IconTagComponent } from '../shared/icon/icon-tag';
import { environment } from 'src/environments/environment';
import { IconNotesEditComponent } from '../shared/icon/icon-notes-edit';

@Component({
    selector: 'sidebar',
    templateUrl: './sidebar.html',
    animations: [slideDownUp],
})
export class SidebarComponent implements OnInit, AfterViewInit {
    active = false;
    store: any;
    activeDropdown: string[] = [];
    parentDropdown: string = '';
    menuItems: MenuItem[] = [];

    constructor(
        public translate: TranslateService,
        public storeData: Store<any>,
        public router: Router,
        private accessService: AccessService,
    ) {
        this.initStore();
    }

    async initStore() {
        this.storeData
            .select((d) => d.index)
            .subscribe((d) => {
                this.store = d;
            });
    }

    logo = `/assets/images/${environment.iconRef}-logo.png`;

    hasAccess(gruposNe: number[]) {
        return gruposNe.some((grupo) => this.accessService.access.perfis.some((p: any) => p.tiposUsuarioId == grupo));
    }

    tiposUsuarioId: any;
    data: any;

    ngOnInit() {
        this.setActiveDropdown();
        const dataString = localStorage.getItem('access');
        if (dataString !== null) {
            this.data = JSON.parse(dataString);
        }

        this.tiposUsuarioId = this.data.tiposUsuarioId;

        this.renderTranslateManual();
    }

    getFilteredMenu(): MenuItem[] {
        debugger
        const names = Object.getOwnPropertyNames(this.access.perfil).filter((n) => this.access.perfil[n] === true);

        return MENU_ITEMS.filter((item) => {
            const hasAccessToItem = item.keys.some((s) => names.some((n) => n == s) || s.length == 0);
            if (hasAccessToItem && item.subItems) {
                item.subItems = item.subItems.filter((subItem) => subItem.keys.some((s) => names.some((n) => n == s)|| s.length == 0));
            }
            return hasAccessToItem;
        }).map((item) => ({
            ...item,
            subItems: item.subItems || [],
        }));
    }

    renderTranslateManual = () => {
        this.translate.getTranslation('pt').subscribe({
            next: (result) => {
                this.menuItems = this.getFilteredMenu().map((m) => {
                    return {
                        ...m,
                        label: result[m.translationKey] || m.translationKey,
                        subItems: m.subItems?.map((s) => {
                            return {
                                ...s,
                                label: result[s.translationKey] || s.translationKey,
                            };
                        }),
                    };
                });
            },
        });
    };

    ngAfterViewInit(): void {
        this.getFilteredMenu();
    }

    setActiveDropdown() {
        const selector = document.querySelector('.sidebar ul a[routerLink="' + window.location.pathname + '"]');
        if (selector) {
            selector.classList.add('active');
            const ul: any = selector.closest('ul.sub-menu');
            if (ul) {
                let ele: any = ul.closest('li.menu').querySelectorAll('.nav-link') || [];
                if (ele.length) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele.click();
                    });
                }
            }
        }
    }

    get access() {
        return this.accessService.access;
    }

    getIconComponent(iconName: string) {
        const iconMap: { [key: string]: any } = {
            'icon-menu-dashboard': IconMenuDashboardComponent, // home
            'icon-airplay': IconAirplayComponent,
            'icon-map-pin': IconMapPinComponent,
            'icon-menu-documentation': IconMenuDocumentationComponent,
            'icon-menu-forms': IconMenuFormsComponent,
            'icon-menu-elements': IconMenuElementsComponent,
            'icon-menu-datatables': IconMenuDatatablesComponent,
            'icon-tag': IconTagComponent,
            'icon-menu-users': IconMenuUsersComponent, // Dois Usuários
            'icon-user': IconUserComponent, // Um usuário
            'icon-folder': IconFolderComponent,
            'icon-box': IconBoxComponent, // Caixa fechada
            'icon-cash-banknotes': IconCashBanknotesComponent,
            'icon-menu-contacts': IconMenuContactsComponent,
            'icon-menu-authentication': IconMenuAuthenticationComponent,
            'icon-menu-tables': IconMenuTablesComponent,
            'icon-notes-edit': IconNotesEditComponent,
        };
        return iconMap[iconName] || null;
    }

    toggleMobileMenu() {
        if (window.innerWidth < 1024) {
            this.storeData.dispatch({ type: 'toggleSidebar' });
        }
    }

    toggleAccordion(name: string, parent?: string) {
        if (this.activeDropdown.includes(name)) {
            this.activeDropdown = this.activeDropdown.filter((d) => d !== name);
        } else {
            this.activeDropdown.push(name);
        }
    }
}
